<template>
  <div v-if="testAttempt">
    <form>
      <table class="section-style2 section-style3 bg-gray-av">
        <tr>
          <td><h3>{{ translate('test-attempt.invoice') }}</h3></td>
          <td><h3>{{ translate('test-attempt.address') }}</h3></td>
          <td></td>
        </tr>
        <tr>
          <td>
            <p><b>{{ testAttempt.invoice.full_name }}</b></p>
            <p><a href="#">{{ testAttempt.invoice.email }}</a> <br>
              {{ testAttempt.invoice.mobile_phone_number }}</p>
          </td>
          <td>
            <p>
              {{ testAttempt.invoice.address }}<br>
              {{ testAttempt.invoice.zip + ' ' + testAttempt.invoice.city }} <br>
              {{ testAttempt.invoice.country }}
            </p>
          </td>
          <td>
            <a :href="'/invoices/' + testAttempt.invoice.id + '/edit'" class="icon-table-av edit-av"></a>
            <label class="checkbox-av">
              <input type="checkbox" checked="checked" name="">
              <i></i>
            </label>
          </td>
        </tr>
      </table>

      <table class="section-style2 section-style3 bg-gray-av">
        <tr>
          <td><h3>{{ translate('test-attempt.participant_data') }}</h3></td>
          <td><h3>{{ translate('test-attempt.address') }}</h3></td>
          <td></td>
        </tr>
        <tr v-for="participant in completedParticipants">
          <td>
            <p><b>{{ participant.full_name }}</b></p>
            <p><a href="#">{{ participant.email }}</a> <br> {{ participant.mobile_phone_number }}</p>
          </td>
          <td>
            <p>{{ participant.address }}<br> {{ participant.zip + ' ' + participant.city }} <br>
              {{ participant.country }}</p>
          </td>
          <td>
            <a v-if="!participant.synced" :href="'/participants/' + participant.id + '/edit'"
               class="icon-table-av edit-av"></a>
            <label class="checkbox-av">
              <input type="checkbox" :checked="participant.completed" name="">
              <i></i>
            </label>
          </td>
        </tr>

        <tr v-for="participant in incompleteParticipants">
          <td>
            <p class="h3">
              <a :href="'/participants/' + participant.id + '/edit'" class="mr-2">
                  {{ translate('test-attempt.fill') }}
              </a>
              <button class="btn btn-sm btn-primary"
                      v-if="participant.main_account"
                      @click.prevent="copyFromInvoice"
                      :disabled="updateTestAttemptForm.busy">
                {{ translate('test-attempt.copy_from_invoice') }}
              </button>
            </p>
          </td>
          <td></td>
          <td>
            <a :href="'/participants/' + participant.id + '/edit'" class="icon-table-av edit-av"></a>
            <label class="checkbox-av">
              <input type="checkbox" :checked="participant.completed" name="">
              <i></i>
            </label>
          </td>
        </tr>
      </table>

      <div class="style-block-av style-block-av-mobile">
        <div>
          <button class="btn btn-primary float-right"
                  @click.prevent="completeParticipantsData"
                  :disabled="!readyForSubmit || updateTestAttemptForm.busy"
                  v-if="testAttempt.status !== 'completed'">
            {{ translate('test-attempt.complete') }} <i class="fa fa-angle-right"></i>
          </button>
          <a href="/test-attempts" class="btn btn-link float-right">{{ translate('test-attempts.title') }}</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ['testAttempt'],

  mixins: [require('../../../../resources/js/mixin')],

  data () {
    return {
      updateTestAttemptForm: new AppForm({}),
    };
  },

  computed: {
    completedParticipants () {
      return this.testAttempt.participants.filter(participant => participant.completed);
    },

    incompleteParticipants () {
      return this.testAttempt.participants.filter(participant => !participant.completed);
    },

    readyForSubmit () {
      return this.testAttempt.participants.filter(participant => !participant.completed).length === 0;
    }
  },

  methods: {
    completeParticipantsData () {
      App.put('/api/test-attempts/' + this.testAttempt.id + '/complete', this.updateTestAttemptForm)
        .then(() => {
          window.location.href = '/test-attempts';
        });
    },

    copyFromInvoice () {
      let self = this;

      App.put('/api/test-attempts/' + this.testAttempt.id + '/copy-from-invoice', this.updateTestAttemptForm)
        .then(() => {
          window.location.href = '/test-attempts/' + self.testAttempt.id;
        });
    },
  }
};
</script>
